import AppStorage from '@Services/AppStorage';

import {
  RECEIVED_RECENT_HISTORY,
  RECEIVED_SAVED_HISTORY,
  HANDLE_VIEW_SAVE_MODAL,
  HANDLE_NAME_CHANGE,
  ON_SUBMIT_SAVE,
  ON_SUBMIT_COMPLETE,
  HANDLE_VIEW_DELETE_MODAL,
  ON_DELETE,
  ON_DELETE_COMPLETE,
  ON_SAVE_UNLOAD,
} from './Constants';

export const initialState = {
  recentHistory: [],
  savedHistory: [],
  isRecentHistoryLoaded: false,
  isSavedHistoryLoaded: false,
  historyTypes: {},
  showSaveModal: false,
  itemToBeSaved: {},
  itemToBeSavedContext: '',
  saveModalTitle: '',
  saveModalNameInput: '',
  isInputTouched: false,
  isSaveInProgress: false,
  saveResult: {},
  error: {},
  itemTobeDeleted: {},
  showDeleteModal: false,
  isDeleteInProgress: false,
  itemIndex: 0,
  groupItemIndex: 0,
};

// eslint-disable-next-line default-param-last
export default function historyReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVED_RECENT_HISTORY: {
      const { recentHistory, historyTypes } = action;
      AppStorage.instance.set('HistoryTypes', historyTypes);
      return { ...state, recentHistory, historyTypes, isRecentHistoryLoaded: true };
    }
    case RECEIVED_SAVED_HISTORY: {
      const { savedHistory, historyTypes } = action;
      AppStorage.instance.set('HistoryTypes', historyTypes);
      return { ...state, savedHistory, historyTypes, isSavedHistoryLoaded: true };
    }
    case HANDLE_VIEW_SAVE_MODAL: {
      return {
        ...state,
        showSaveModal: action.show,
        itemToBeSaved: { ...action.historyItem },
        itemToBeSavedContext: action.show ? action.itemToBeSavedContext : '',
        saveModalTitle: action.show ? action.title : '',
        isInputTouched: !action.show ? false : state.isInputTouched,
        saveModalNameInput: action.show && action.title === 'Rename' ? action.historyItem.searchName : '',
        error: !action.show ? {} : state.error,
        saveResult: !action.show ? {} : state.saveResult,
        itemIndex: action.itemIndex,
        groupItemIndex: action.groupItemIndex,
      };
    }
    case HANDLE_NAME_CHANGE: {
      return { ...state, saveModalNameInput: action.value, isInputTouched: true };
    }
    case ON_SUBMIT_SAVE: {
      return { ...state, isSaveInProgress: true };
    }
    case ON_SUBMIT_COMPLETE: {
      const { groupItemIndex } = state;
      if (action.responseType === 'success' && !action.isRename) {
        return { ...state, isSaveInProgress: false, saveResult: { ...action.payload } };
      }
      if (action.responseType === 'success' && action.isRename) {
        const updatedSavedItems =
          state.savedHistory.length > 0 &&
          state.savedHistory[groupItemIndex] &&
          state.savedHistory[groupItemIndex].items &&
          state.savedHistory[groupItemIndex].items.length > 0
            ? [...state.savedHistory[groupItemIndex].items]
            : [];
        updatedSavedItems[state.itemIndex].searchName = state.saveModalNameInput;
        const updatedSavedHistory = [...state.savedHistory];
        updatedSavedHistory[groupItemIndex].items = [...updatedSavedItems];
        return { ...state, isSaveInProgress: false, saveResult: { ...action.payload }, savedHistory: [...updatedSavedHistory] };
      }
      return { ...state, isSaveInProgress: false, error: { ...action.payload } };
    }
    case HANDLE_VIEW_DELETE_MODAL: {
      return {
        ...state,
        itemTobeDeleted: action.historyItem,
        showDeleteModal: action.show,
        itemIndex: action.itemIndex,
        groupItemIndex: action.groupItemIndex,
      };
    }
    case ON_DELETE: {
      return { ...state, isDeleteInProgress: true };
    }
    case ON_DELETE_COMPLETE: {
      const { groupItemIndex } = state;
      if (action.responseType === 'success') {
        const updatedSavedItems =
          state.savedHistory.length > 0 &&
          state.savedHistory[groupItemIndex] &&
          state.savedHistory[groupItemIndex].items &&
          state.savedHistory[groupItemIndex].items.length > 0
            ? [...state.savedHistory[groupItemIndex].items]
            : [];
        updatedSavedItems.splice(state.itemIndex, 1);
        const updatedSavedHistory = [...state.savedHistory];
        if (updatedSavedItems.length > 0) {
          updatedSavedHistory[groupItemIndex].items = [...updatedSavedItems];
        } else {
          updatedSavedHistory.splice(groupItemIndex, 1);
        }
        return { ...state, isDeleteInProgress: false, savedHistory: [...updatedSavedHistory] };
      }
      return { ...state, isDeleteInProgress: false };
    }
    case ON_SAVE_UNLOAD: {
      return { ...state, isSavedHistoryLoaded: false };
    }
    default: {
      return state;
    }
  }
}
